import React from 'react';
import { Link } from 'react-router-dom';

const PublicHomePage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section with Video */}
      <section className="bg-black relative">
        <div className="max-w-7xl mx-auto">
          <div className="relative">
            <iframe 
              src="https://player.vimeo.com/video/343366397" 
              width="100%" 
              height="564" 
              frameBorder="0" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="w-full h-96 md:h-[564px]"
            ></iframe>
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-8 text-center">
              <h3 className="text-2xl font-bold mb-2">Lenexa Public Market</h3>
              <p className="text-lg">Thanks to everyone who came out for an evening with Doulos at the Lenexa Public Market!</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-white" id="band">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Doulos</h2>
          <p className="text-xl italic text-gray-600 mb-8">Welcome to the Doulos Experience!</p>
          
          <div className="text-left space-y-6 text-lg text-gray-700">
            <p>
              Looking for a sound beyond the mundane? Look no further than Doulos. Whether it is the high energy "Mystery", 
              the soul-searching "Time", or the cinematic experience of "Sand", our original songs are fresh and unique in a 
              sea of the ordinary.
            </p>
            <p>
              Weaved within our songs, you will catch glimpses of our musical influences; bands such as Led Zeppelin, Pink Floyd, 
              Rush, Yes, King's X, and Genesis, et al. In our performances, you will on occasion hear us cover songs from bands 
              like Foo Fighters, Stone Temple Pilots, Collective Soul, Pink Floyd, and others.
            </p>
            <p className="font-semibold text-xl text-center">
              Doulos... beyond the ordinary.
            </p>
            <p className="text-center text-sm text-gray-500">
              Doulos is an alternative/progressive rock band based out of Kansas City.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Navigation */}
      <section className="py-12 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/about" className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-200 text-center group">
              <div className="text-4xl mb-4">🎵</div>
              <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-600">About the Band</h3>
              <p className="text-gray-600">Learn more about our story and influences</p>
            </Link>
            <Link to="/music" className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-200 text-center group">
              <div className="text-4xl mb-4">🎧</div>
              <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-600">Our Music</h3>
              <p className="text-gray-600">Listen to our original songs</p>
            </Link>
            <Link to="/contact" className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition duration-200 text-center group">
              <div className="text-4xl mb-4">📧</div>
              <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-600">Get In Touch</h3>
              <p className="text-gray-600">Contact us for bookings</p>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PublicHomePage;